module.exports = __webpack_public_path__ + "img/add-device-mobile.c96788e8.png";